import axios from 'axios';
import env from '@/env';

const baseURL = `${env.api.baseUrl.token}`;
const { clientKey, clientSecret } = env.api;

const instance = axios.create({
  baseURL,
  auth: {
    username: clientKey,
    password: clientSecret,
  },
  headers: {
    'content-type': 'application/x-www-form-urlencoded',
  },
});

export default instance;
